import { createSelector } from "reselect";

export const routesSelector = createSelector(
  (state) => {
    const units = state.unitsReducer.units;
    const routes = state.routesStatus.routes;
    const routesWithUnits = routes.map((route) => {
      return { 
        ...route, 
        type: units[route.route]?.type,
        unitCapacity: units[route.route]?.capacity,
        isMaintenance: units[route.route]?.isMaintenance 
      };
    })
    return routesWithUnits;
  },
  (routes) => routes
);
